import React from 'react';
import './Blog.css';

import Image1 from '../../assets/blogs/blog-1.svg';
import Image2 from '../../assets/blogs/blog-3.svg'; 

const Blog = () => {
    const blogs = [
        {
            title: "Shortcuts, Tools & Workflow Habits for Research, Coding, and Data Analysis",
            url: "https://atiksblogsite.vercel.app/posts/1",
            category: "Productivity",
            date: "September 2025",
            image: Image1
        },
        {
            title: "Win + R Commands for Researchers",
            url: "https://atiksblogsite.vercel.app/posts/3",
            category: "Productivity",
            date: "September 2025",
            image: Image2
        },
        {
            title: "Windows Productivity Toolkit for Researchers",
            url: "https://atiksblogsite.vercel.app/posts/2",
            category: "Productivity",
            date: "September 2025",
            image: Image1
        }
    ];

    return (
        <section className="blog container section" id="blog">
            <h2 className="section__title">Latest Posts</h2>

            <div className="blog__container grid">
                {blogs.map((blog, index) => (
                    <div className="blog__card" key={index}>
                        <div className="blog__thumb">
                            <a href={blog.url} target="_blank" rel="noreferrer">
                                <span className="blog__category">{blog.category}</span>
                            </a>
                            <a href={blog.url} target="_blank" rel="noreferrer">
                                <img src={blog.image} alt={blog.title} className='blog__img' />
                            </a>
                        </div>
                        <div className="blog__details">
                            <h3 className="blog__title">
                                <a href={blog.url} target="_blank" rel="noreferrer">{blog.title}</a>
                            </h3>
                            <div className="blog__meta">
                                <span>{blog.date}</span>
                                <span className="blog__dot">.</span>
                                <span>Atikur Rahman</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Blog;
